import { render } from "./Check.vue?vue&type=template&id=c87f8e2c"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Check.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c87f8e2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c87f8e2c', __exports__)) {
    api.reload('c87f8e2c', __exports__)
  }
  
  module.hot.accept("./Check.vue?vue&type=template&id=c87f8e2c", () => {
    api.rerender('c87f8e2c', render)
  })

}


export default __exports__